import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { Play } from '../types'

interface UsePlaysResult {
  plays: Play[]
  loading: boolean
  error: string | null
}

export function usePlays(): UsePlaysResult {
  const [plays, setPlays] = useState<Play[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchPlays() {
      setLoading(true)
      setError(null)

      const { data, error: supabaseError } = await supabase
        .from('plays')
        .select('*')
        .order('title')

      if (supabaseError) {
        setError(supabaseError.message)
      } else {
        setPlays(data ?? [])
      }

      setLoading(false)
    }

    fetchPlays()
  }, [])

  return { plays, loading, error }
}
